import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {

 district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  user_name: any;
  user_id: any ;
  scheme: any;
  
  course_name: any;
  description: any;
  status: any;
  category: any;
  days: any;
  hours: any;
  customers: any = [];
  summary_activity: any = [];
    MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  
  
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  editmeetingform !:FormGroup;
  CM_id: any;
  uploadFiles: any='';
  // Course_image: any;

  getChangeAssignedTo(assigned_to: any) {
    console.log(assigned_to)
    if (assigned_to === 'District') {
      $('#Check1').css('display','flex')
    } else {
       $('#Check1').css('display','none')
    }
  }


  getChangeToConstituey(value: any) {
    console.log(value);
    this.user_constituency = this.ApiService.all_constituency[value];
      this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
        this.customers = obj.data;
  
      //console.log(obj.data.length);
    });
  }

  handleActivityTypeChange(value: any) {
    console.log(value);
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
        $('#others').css('display', 'none');
    }
  }

 


 



  

  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
      this.user_name = this.ApiService.user_details.firstname;
      this.user_id = this.ApiService.user_details.id;

      console.log(' this.user_name: ',  this.user_name);
      console.log(' this.user_id: ',  this.user_id);

    this.createmeetingform= this.fb.group({
      user_id:['',],
      user_name: ['this.user_name',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      course_name:['',Validators.required],
      scheme:['stalin scheme',],
      category:['All dept'],
      description:['',Validators.required],
      status: ['', Validators.required],
      days: ['', Validators.required],
      hours: ['', Validators.required],
      
      image: ['', [ this.imageSizeValidator(60000)]], // Limit image size to 60 KB
    });
    this.editformInitialize('false');

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit(): void{
    console.log(this.users,this.users.firstname, "sndknsdkjn");
    this.user_id = this.ApiService.user_details.id;
    this.date=new Date();
    this.customers=[] ;
    this.showSpinner();
    this.ApiService.getCourses().subscribe((data: any) => {
     console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      ;})

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.current_date);
    this.createmeetingform.get('activity_time').setValue(this.current_time);
    this.createmeetingform.get('user_name').setValue(this.user_name);

  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
  getdata(){
    this.customers=[];
        for(const prop in this.ApiService.tabledatameeting) {
            this.customers.push(this.ApiService.tabledatameeting[prop])
          }
          this.customers.pop();
    //console.log(this.ApiService.tabledataDA)
    //this.ApiService.viewtableOB();
    

  }

  

  postdata(angForm1 : any) //angForm1
  {
    console.log(angForm1, "dsnkjkdsjnd");
        console.log(this.createmeetingform.status,
          angForm1
       );
       let values = angForm1.value;
       values['image'] = this.uploadFiles;
          this.spinner=true;

  

    this.ApiService.createCourses(values).subscribe((d:any) => {
      console.log(d,"sdndsbjbdsskbskj"); 
      this.spinnerService.hide();
      

      if (d.error) {
        // Error occurred during course creation
        Swal.fire({
          title: "Warning!",
          text: "You are already enrolled in this course",
          icon: "info",
          confirmButtonText: "Okay",
          confirmButtonColor: '#e5183b',
          iconColor: '#e5183b',
        });
      } else {
        // Course created successfully
        console.log("Course Created Successfully!");
        this.spinnerService.hide();
        Swal.fire({
          title: "Course Created Successfully!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: '#015792',
          iconColor: '#015792',
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
                 
            //this.router.navigate(['superadmin/Meetings']);
             //angForm1.reset();
            },

            error => {
                console.log(error);
            });
            
         
    }
//     delete_CM(id : any){
//       console.log(id)
//       if(confirm("Are you sure want to cancel this Course ?")) {
//         console.log("Implement delete functionality here");
//           this.ApiService.deleteCourses(id)
//           .pipe()
//           .subscribe(
//           data => {
//                          Swal.fire({
//   title: "Your course deleted Successfully!",
//    icon: "success",
//                   confirmButtonText: "Okay",
//    confirmButtonColor: 'green',

// }).then((result) => {
//   /* Read more about isConfirmed, isDenied below */
//   if (result.isConfirmed) {
//     window.location.reload();
//   } 
// });
//           },

//           error => {
//               console.log(error);
//           });

//   }
// }
selectFiles(event: any) {
  if (event.target.files[0].size < 60000) {
    const formData: FormData = new FormData();
    formData.append('file', event.target.files[0]);
    this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
      this.uploadFiles = da;
    });
  } else {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: "The size should be less than 60kb",
      showConfirmButton: false,
      timer: 1500
    });
    $('#file').val('');
    this.editmeetingform.get('image')?.setErrors({ 'imageSizeExceeded': true });
    this.createmeetingform.get('image')?.setErrors({ 'imageSizeExceeded': true });

    // Mark the 'image' form control as invalid
  }
}
imageSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    console.log('control.value && control.value.size: ', control.value && control.value.size);

    if (control.value && control.value.size) {
      const fileSize = control.value.size; // Get the size of the file
      if (fileSize > maxSize) {
        console.log('maxSize: ', maxSize);
        return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        
      }
    }
    return null; // Return null if the size is within the limit
  };
}

delete_CM(id: any) {
  console.log(id);
  Swal.fire({
      title: 'Confirm Deletion',
      text: 'Are you sure you want to cancel this Course?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#015792',
      cancelButtonColor: '#e5183b',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
  }).then((result) => {
      if (result.isConfirmed) {
          console.log("Implement delete functionality here");
          this.ApiService.deleteCourses(id)
              .subscribe(
                  data => {
                      Swal.fire({
                          title: 'Course Deleted',
                          text: 'Your course has been deleted successfully!',
                          icon: 'success',
                          iconColor: '#e5183b',
                          confirmButtonText: 'Okay',
                          confirmButtonColor: '#e5183b'
                      }).then((result) => {
                          if (result.isConfirmed) {
                              window.location.reload();
                          }
                      });
                  },
                  error => {
                      console.log(error);
                  }
              );
      }
  });
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
//dropdown overlay reduced for mobileview
    const popupelement = this.elementRef.nativeElement.querySelector('.modal-content');
    if (popupelement) {
      const targetElement = popupelement.querySelector('.dropdown-list');
      if (targetElement) {
        this.renderer.setStyle(targetElement, 'overflow-y', 'hidden');
      }
    }
  }
  CM_course_name:any;
  CM_course_description:any;
  CM_scheme:any;
  CM_category: any;
  CM_days: any;
  CM_hours:any;
  CM_status: any;
  CM_name: any;

  Course_image: any;

editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton,"dsbskdb");
    //console.log(a.date)
    if (editbutton == 'edit') {
      $('#card_title').html('Edit Course Details');
      this.editfield = true;
    } else {
      $('#card_title').html('Course Details');
      this.editfield = false;
    }
      this.CM_name = this.user_name;
      this.CM_course_name = a.course_name;
      this.CM_course_description=a.course_description;
      console.log('this.CM_course_description: ', this.CM_course_description);
      // this.CM_scheme = a.scheme;
      // this.CM_category = a.category;
      this.CM_days = a.days;
      this.CM_hours = a.hours;
      this.CM_status=a.status;
      this.CM_id = a.id;
      this.Course_image = a.image; 
      this.uploadFiles = a.image;
   
    
          
          this.editformInitialize(false);
          // this.editmeetingform.get('user_name').setValue(this.CM_name);
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('description').setValue(a.course_description);
    this.editmeetingform.get('days').setValue(a.days);
    this.editmeetingform.get('hours').setValue(a.hours);
    this.editmeetingform.get('status').setValue(a.status);
    this.editmeetingform.get('user_name').setValue(this.user_name);
    // this.editmeetingform.get('scheme').setValue(a.scheme);
    // this.editmeetingform.get('category').setValue(a.category);
    //
     }
          
    
       
          
          
  editformInitialize(a){
    this.editmeetingform= this.fb.group({
      user_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      course_name:['',Validators.required],
      scheme:['stalin scheme'],
      category:['all dept'],
      description:['',Validators.required],
      status: ['', Validators.required],
      days: ['', Validators.required],
      hours: ['', Validators.required],
      image: ['',[this.imageSizeValidator(60000)]],
  });
  }

  updatedata(updateform:any,id:any){
    console.log(updateform.value,this.CM_id,"lmdldk");  
    // this.spinner = true;
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    this.ApiService.updateCourses(this.CM_id, values).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        setTimeout(() => {
                            Swal.fire({
  title: "Your course updated Successfully!",
   icon: "success",
   iconColor: '#015792',
  confirmButtonText: "Okay",
   confirmButtonColor: '#015792',

}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    window.location.reload();
  } 
});
        },100)
      })
      
   
  }
//reset form values in createform
  Formreset(){
      this.createmeetingform.reset();
      this.hidden=true;
      this.MeetingOptions='';
      this.participantsptions='';
  }

}
